<template>
    <component
        :is="tag"
        v-if="label !== ''"
        :class="[
            'SubTab',
            active && 'SubTab--active',
        ]"
        role="navigation"
        :disabled="disabled"
        @click="$emit('navigate', to)"
    >
        <!-- @slot Can be used instead of the `label` prop -->
        <slot>{{ label }}</slot>
    </component>
</template>
<script>
export default {
    name: 'RPSubTab',
    props: {
        tag: {
            type: String,
            default: 'button',
        },
        size: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        /**
         * An object with a `name` property matching a route name
         */
        to: {
            type: Object,
            default: () => ({name: ''}),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        /**
         * Whether this is the currently active menu item in a list.
         */
        activeTab: {
            type: String,
            default: 'default',
        },
        isActive: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        active(){
            return !this.disabled
                    && (this.activeTab === this.to.name
                        || this.isActive);
        },
    },
};
</script>
<style lang="scss">
    .SubTab {
        padding: 0.25rem 0.5rem;
        color: $text-grey;
        font-size: 1rem;
        border-radius: 4px;
        border-width: 0;
        white-space: nowrap;
        display: flex;
        &:hover{
            color: $text-dark;
        }
        &:active,
        &--active {
            color: $text-link;
            &:hover{
                color: $text-link;
            }
        }
        &:focus {
            outline: none;
            box-shadow: 0 0 4px $highlight-blue;
            background: $primary-50;
        }
        &:disabled {
            opacity: 0.25;
        }
    }
</style>

<docs>
The `RPSubTab` component is generally used within navbars such as `RPSidebar`, `RPTopNav`, and `RPTopbar`.

Basic example:
```vue
<RPSubTab
    :to="{name: 'test-route'}"
    :activeTab="myValString"
    @navigate="n => myValString = myValString === '' ? n.name : ''">My Label</RPSubTab>
<br>
<RPSubTab :isActive="true">Active Prop</RPSubTab>
<br>
<RPSubTab :to="{name: 'ParentRoute'}" :activeTab="'ParentRoute'" label="Route Match"></RPSubTab>
<br>
<RPSubTab :disabled="true">Disabled</RPSubTab>
```
</docs>
